import { Modal, Image } from "@mantine/core";
import { CDN_URL } from "../../../constant";

const ImagePopUp = ({
	isInfoImageSpotOpen,
	setIsInfoImageSpotOpen,
	infoImageSpotDetails,
}) => {
	return (
		<>
			<Modal
				centered
				size="lg"
				opened={isInfoImageSpotOpen}
				onClose={() => setIsInfoImageSpotOpen(false)}
				title={infoImageSpotDetails.text}
				styles={{
					modal: { backgroundColor: "#040F1F" },
					title: { color: "#ffffff", fontWeight: "700" },
				}}
			>
				<Image src={CDN_URL + infoImageSpotDetails.url} fit="cover" />
			</Modal>
		</>
	);
};

export default ImagePopUp;
